import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { useUser } from '@/shared/hooks/useAuth';
import { RoleDashboard } from './RoleDashboard';
import { SurajMishraDashboard } from './pages/SurajMishraDashboard';
import { LeaveActions, LeaveHostProvider } from './infrastructure/widgets/WelcomeBanner';

export function DashboardPage() {
  const user = useUser();
  const username = String(user?.username || '').trim().toLowerCase();
  const displayName = String((user as any)?.display_name || (user as any)?.displayName || '').trim().toLowerCase();
  const role = String(user?.role || '').trim().toLowerCase();
  const dept = String(user?.department || '').trim().toLowerCase();

  // Suraj Mishra Ji (bdm1 / General Manager & Admin) leads the sales team and manages his own personal BDM pipeline.
  // His dashboard gives him:
  // 1. Saare Employees Ka End-to-End Data (Scoreboard, Attendance, Pipeline, DSR, GPS, Deals)
  // 2. Unka Khudka End-to-End Data (Personal BDM 1 Leads, Quotes, Deals, Followups)
  const isSurajMishra =
    ['bdm1', 'suraj', 'surajmishra'].includes(username) ||
    displayName.includes('suraj mishra') ||
    (role === 'admin' && ['management', 'general_manager'].includes(dept) && username !== 'owner' && username !== 'sumit.dwivedi');

  return <LeaveHostedDashboard>{isSurajMishra ? <SurajMishraDashboard /> : <RoleDashboard />}</LeaveHostedDashboard>;
}

/**
 * Apply for Leave sits in each dashboard's WelcomeBanner. A dashboard that has
 * no banner (one with its own bespoke header) still gets the actions, in a
 * small row above it — never both.
 */
function LeaveHostedDashboard({ children }: { children: ReactNode }) {
  const [banners, setBanners] = useState(0);
  const register = useCallback(() => {
    setBanners((n) => n + 1);
    return () => setBanners((n) => n - 1);
  }, []);
  const host = useMemo(() => ({ register }), [register]);
  return (
    <LeaveHostProvider value={host}>
      {banners === 0 && <div className="mb-3 flex justify-end"><LeaveActions /></div>}
      {children}
    </LeaveHostProvider>
  );
}
